import React from 'react';
import cx from 'classnames';
import './styles.scss';
import RightArrowImg from '../../../assets/images/right-arrow.svg';
import CardPostPe from '../CardPostPe';
import FlexBox from '../FlexBox';
const ActionBlock = ({
	activeBlockClass,
	activeBlockStyle,
	onClick,
	img,
	leftText,
	text,
	rightContent,
	hasAnimation,
	noClickable,
	animationClass,
	isItemSelected,
}) => {
	return (
		<CardPostPe
			noBorder
			variant="white"
			cardClass={cx(
				activeBlockClass,
				'mr-0 action-block-card',
				!hasAnimation && 'animated',
				!noClickable && 'clicking-animation',
				animationClass ? animationClass : 'fadeInRight',
				isItemSelected && 'activeBankSelected',
			)}
			onClick={() => {
				onClick && onClick();
			}}
			cardStyle={activeBlockStyle}>
			<FlexBox flexBoxClass="action-block-content" justifyBetween alignCenter={!rightContent} alignTop={rightContent}>
				<FlexBox alignCenter flexBoxClass={cx(rightContent ? 'w-80' : '')}>
					{leftText ? leftText : img ? <img src={img} className="mr-r-20 icon" /> : ''}
					<p className="fs-16-postpe font-regular">{text}</p>
				</FlexBox>
				{rightContent ? rightContent : <img src={RightArrowImg} className="w-8 right-content" />}
			</FlexBox>
		</CardPostPe>
	);
};
export default ActionBlock;
